import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import Button from 'components/buttons/button';
import { useState } from 'react';

const SetupForm = ({ onComplete }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return null;
    }

    // TODO: This should inform the parent that it's "processing" and lock out the submit button
    const { setupIntent, error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        // TODO: This needs to return to the same page.
        // How-to docs https://stripe.com/docs/payments/save-and-reuse?platform=web#web-submit-payment-details
        // API doc https://stripe.com/docs/js/setup_intents/confirm_setup
        // The premium page (also maybe coins?) will need to know this is a mid-setup payment
        return_url: 'https://example.com/account/payments/setup-complete',
      },
      redirect: 'if_required',
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      onComplete({ paymentMethodId: setupIntent.payment_method });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Button theme="blue" disabled={!stripe} className="mt-2">
        Add Payment Method
      </Button>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

export default SetupForm;
